The optional hirer ID to receive events from.

By default webhook subscriptions will send events from all hirers the partner has access to.
Providing a hirer ID will filter events to the specified hirer.
